<template>
    <div v-if="display">
        <div class="container header-margin">

            <div class="text-center p-2 text-color text-area">
                <h2 class="main_title">{{ $t('aube_quest.registration.title') }}</h2>
            </div>

            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
                <div>Quest ID: {{ formData.quest_id }}</div>
                <div>Connector ID: {{ formData.connectorMemberId }}</div>
                <div>{{ $t('aube_quest.connector_start_date') }}: {{ formData.joinedDate }}</div>
                <div v-if="errors.quest_id" class="error-message">{{ errors.quest_id }}</div>
            </div>

            <div v-if="errors_token.timeOverToken">
                <!-- トークンデータ24時間超過 -->
                <div class="show-check-email-message" v-html="$t('aube_quest.registration.tokenRegistrationTimeOverText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.aube-quest.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors_token.notLatestToken">
                <!-- 対象のトークンが最新のトークンではない -->
                <div class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.aube-quest.com/login" role="button">{{$t('aube_quest.btn_close') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors_token.notExistToken">
                <!-- トークンデータが存在しない -->
                <div class="text-center p-2">
                    {{ $t('auth.notExistTokenText') }}
                </div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.aube-quest.com/login" role="button">{{$t('aube_quest.btn_close') }}</a>
                    </div>
                </div>
            </div>

            <div v-if="email">
                <div class="tab-content p-2" >
                    <div class="row no-gutters text-center navigation">
                        <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                        <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                        <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                        <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title4') }}</p></div>
                    </div>

                    <div class="text-center p-2 text text-color text-area" style="margin-bottom: 20px;">
                        <h3 class="sub_title">{{ $t('aube_quest.registration.create_title') }}</h3>
                    </div>

                    <div>
                        <div class="form-group row">
                            <label class="mail_value" style="margin-left:15px; margin-bottom:15px;">{{ $t('auth.createMessagesAube') }}</label>
                        </div>
                        <div class="form-group row">
                            <label style="width:180px;" for="mail_value" class="col-sm-4 col-form-label mail_label pre">{{ $t('aube_quest.registration.email_qId') }}</label>
                            <div class="col-sm-4 mail_value">
                                {{email ? email : '-'}}
                            </div>
                        </div>
                        <form @submit.prevent="handleOnSubmit">
                            <div class="form-group row">
                                <label style="width:180px;" for="first_name" class="col-sm-4 col-form-label">{{ $t('aube_quest.registration.first_name') }}</label>
                                <div class="col-sm-4 values">
                                    <input
                                        v-model="formData.first_name"
                                        onpaste="return false"
                                        type="text"
                                        id="first_name"
                                        name="first_name"
                                        class="form-control"
                                        v-bind:class="{ 'is-invalid': errors.first_name}"/>
                                    <p class="text-size">{{ $t('auth.createUnderMessagesAube') }}</p>
                                    <div v-if="errors.first_name" class="invalid-feedback invalid-errors-text">{{ $t('errors.' + errors.first_name) }}</div>
                                </div>
                                <div v-if="(!errors.first_name)" class="invalid-errors-hiddens-text"></div>
                            </div>

                            <div class="form-group row">
                                <label style="width:180px;" for="last_name" class="col-sm-4 col-form-label">{{ $t('aube_quest.registration.last_name') }}</label>
                                <div class="col-sm-4 values">
                                    <input
                                        v-model="formData.last_name"
                                        onpaste="return false"
                                        type="text"
                                        id="last_name"
                                        name="last_name"
                                        class="form-control"
                                        v-bind:class="{ 'is-invalid': errors.last_name}"/>
                                    <p class="text-size">{{ $t('auth.createUnderMessagesAube') }}</p>
                                    <div v-if="errors.last_name" class="invalid-feedback invalid-errors-text">{{ $t('errors.' + errors.last_name) }}</div>
                                </div>
                                <div v-if="(!errors.last_name)" class="invalid-errors-hiddens-text"></div>
                            </div>

                            <div class="form-group row">
                                <label style="width:180px;" class="col-sm-4 col-form-label pre" v-html="$t('aube_quest.registration.password')" for="password"></label>
                                <div class="col-sm-4 values">
                                    <input v-model="formData.password"
                                        type="password"
                                        autocomplete="off"
                                        id="password"
                                        name="password"
                                        class="form-control"
                                        v-bind:class="{ 'is-invalid': errors.password}"/>
                                    <div style="overflow:visible;text-align:right;" class="password-space">
                                        <img src="../../images/info_purple_btn.png" ref="infoMark" class="info-mark" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction" @click="mouseClickAction"/>
                                        <div v-show="hoverFlag" class="balloon1" ref="balloon">
                                            <p class="passwordInfo" align="left">{{ $t('account.password.passwordInfoMessageAube') }}</p>
                                        </div>
                                    </div>
                                    <div v-if="errors.password" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.password) }}</div>
                                </div>
                            </div>
                            <div v-if="(!errors.password)" class="invalid-errors-hiddens-pass"></div>

                            <div class="form-group row">
                                <label style="width:180px;" class="col-sm-4 col-form-label pre" v-html="$t('aube_quest.registration.passwordAgain')" for="passwordAgainAube"></label>
                                <div class="col-sm-4 values">
                                    <input v-model="formData.password_confirmation"
                                        type="password"
                                        autocomplete="off"
                                        id="password_confirmation"
                                        name="password_confirmation"
                                        class="form-control"
                                        v-bind:class="{ 'is-invalid': errors.password_confirmation}"/>
                                    <div v-if="errors.password_confirmation" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.password_confirmation) }}</div>
                                </div>
                                <div v-if="(!errors.password_confirmation)" class="invalid-errors-password-confirmation-hiddens"></div>
                            </div>

                            <div class="form-group row">
                                <label style="width:180px;" for="birthDate" class="col-sm-4 col-form-label">{{ $t('account.edit.birthDate') }}</label>
                                <div class="col-sm-4 values">
                                    <DatePicker
                                        onpaste="return false"
                                        readonly
                                        :options = "options"
                                        :selDate = "formData.birth_date"
                                        v-model = "formData.birth_date"
                                        :class="{ 'is-invalid': errors.birth_date}"
                                        class="form-control col-form-label"
                                    />
                                    <div v-if="errors.birth_date" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.birth_date) }}</div>
                                </div>
                                <div v-if="(!errors.birth_date)" class="invalid-errors-hiddens-birthDate"></div>
                            </div>

                            <table class="table text-center">
                                <tr>
                                    <th class="back_btn" style="text-align: right;">
                                        <button type="button" class="btn btn-outline-primary ml-2 non-active-color-box btn-back;" @click="handleOnFormClear()">{{ $t('aube_quest.btn_clear') }}</button>
                                    </th>
                                    <th class="submit_btn" style="text-align: left;">
                                        <button type="submit" class="btn btn-primary mr-2 active-color-box;">{{ $t('aube_quest.btn_confirm') }}</button>
                                    </th>
                                </tr>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from '../../../../services/UserService';
    import QuestService from '../../../../services/QuestService';
    import DatePicker from "../../../../components/DatePicker";
    import RecaptchaMixin from '../../../../utils/RecaptchaMixin';
    import questService from "../../../../services/QuestService";

    export default {
        name: 'registration-module',
        mixins: [RecaptchaMixin],

        components: {
            DatePicker
        },

        data() {
            return {
                hoverFlag: false,
                hasMouseOverEvent: false,
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                initDate: this.getDefaultDate(),
                token: null,
                param: null,
                email: null,
                options: {
                    defaultDate: this.getDefaultDate(),
                },
                display: false,
            }
        },

        created() {
            this.token = this.$route.query.token;
            this.fetchQuestIdData(this.token);
            this.fetchUserData(this.token);
        },
        methods: {
            ValidateFirstName() {
                this.formData.first_name = this.formData.first_name.replace(/[^A-Z]+/g,'')
            },
            ValidateLastName() {
                this.formData.last_name = this.formData.last_name.replace(/[^A-Z]+/g,'')
            },
            mouseOverAction(e) {
                this.hasMouseOverEvent = true
                this.hoverFlag = true
                this.offsetLeft =　e.target.offsetLeft
                if (window.matchMedia( "(max-width: 479px)" ).matches) {
                    /* ウィンドウサイズが 479px以下(SP)の場合に有効*/
                    this.offsetLeft = Number(this.offsetLeft) - 310
                    if(this.offsetLeft < 0){
                        this.offsetLeft = 10;
                    }
                }
                this.$refs.balloon.style.left = this.offsetLeft + 'px'
                this.$refs.balloon.style.top = e.target.offsetTop + 'px'
            },
            mouseLeaveAction(e) {
                this.hoverFlag = false
                this.hasMouseOverEvent = false
            },
            mouseClickAction() {
                if(!this.hasMouseOverEvent) {
                    this.hoverFlag = !this.hoverFlag
                } else {
                    this.hasMouseOverEvent = false
                }
            },
            getDefaultFields() {
                return {
                    account: '',
                    first_name: '',
                    last_name: '',
                    birth_date: '',
                    password: '',
                    password_conversion: '',
                    password_confirmation: '',
                    timeOverToken: '',
                    notLatestToken: '',
                    notExistToken: '',
                    quest_id: '',
                    connectorMemberId: '',
                    joinedDate: '',
                };
            },
            getDefaultDate() {
                const date = new Date();
                const day = ("0"+ date.getDate()).slice(-2);
                const month = ("0"+(date.getMonth() + 1)).slice(-2);

                return "1970-" + month + "-" + day;
            },
            handleOnFormClear() {
                sessionStorage.removeItem('formData')
                this.formData = this.getDefaultFields();
                this.errors = this.getDefaultFields();
            },
            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                const recaptchaToken = await this.recaptchaGetKey();
                try {
                    this.formData.token = this.token;
                    this.formData.param = this.$route.query.a;
                    this.formData.account = this.email;
                    const result = await QuestService.confirmRegistrationAubeQuest({
                        token: this.formData.token,
                        ...this.formData,
                        recaptchaToken
                    });
                    if (this.formData.birth_date == "") {
                        this.formData.birth_date = this.getDefaultDate();
                    }
                    var count = this.formData.password_confirmation.length;
                    this.formData['password_conversion'] = '';
                    for (let i = 0; i < count; i++) {
                        this.formData['password_conversion'] = this.formData['password_conversion'] + '*';
                    }
                    sessionStorage.formData = JSON.stringify(this.formData)
                    this.$router.push({
                        path: '/registration-quest/confirm',
                        query: {
                            token: this.formData.token
                        }
                    })
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
            async fetchQuestIdData(token) {
                try {
                    const result = await UserService.getQuestIdByToken(token);

                    this.formData.quest_id = result.data.quest_id || '';
                    if (!result.data.quest_id) {
                        this.errors.quest_id = this.$t('aube_quest.verify_error.quest_id_not_found');

                        return;
                    }
                    await this.getConnector(this.formData.quest_id);
                } catch (error) {
                    if (error.response.data.errors) {
                        error.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors_token[errItem.field] = errItem.field;
                                this.$router.push('/registration-quest/error?message=' + errItem.field);
                            }
                        })
                    }
                }
            },
            async fetchUserData(token) {
                this.errors_token = this.getDefaultFields();
                sessionStorage.removeItem('mailData')

                if (token == undefined && sessionStorage.formData) {
                    token = JSON.parse(sessionStorage.formData).token;
                }
                try {
                    const result = await UserService.getUserAubeQuestConfirmDataByToken(token);
                    if (result.data.member_type_id == 2100 ||
                        result.data.member_type_id == 2200
                    ) {
                        this.$router.push('/');
                    } else {
                        this.display = true
                        this.email = result.data.email;
                        if (sessionStorage.formData) {
                            this.formData = JSON.parse(sessionStorage.formData);
                        }
                        this.maxHeight();
                    }
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors_token[errItem.field] = errItem.field;
                                this.$router.push('/registration-quest/error?message=' + errItem.field);
                            }
                        })
                    }
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },
            async getConnector (questId) {
                try {
                    const result = await questService.getConnectorByQuestId(questId);
                    this.formData.quest_id = result.data.quest_id;
                    this.formData.connectorMemberId = result.data.connector_id;
                    this.formData.joinedDate = result.data.joined_date;
                } catch (error) {
                }
            },
        }
    }
</script>

<style scoped>
    .main_title{
        margin-bottom:15px;
    }
    .hasDatepicker, .form-control-profile{
        display: block;
        width: 100%;
        height: calc(1.6em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: .9rem;
        font-weight: 400;
        line-height: 1.6;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .form-control-birthdate{
        background-color: #ffffff !important;
    }
    .info-mark  {
        position: relative;
        width: 19px;
        height: 19px;
        top: -32px;
        right: -30px;
    }
    .balloon1 {
        position: absolute;
        margin: 1.5em 0;
        padding: 7px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #212529;
        font-size: 16px;
        background: #D0F0D0;
        border-radius: 15px;
        z-index: 2;
        width: 319px;
        left: 351px;
        top: 124px;
    }
    .balloon1 p {
        top:192px;
        margin: 0;
        padding: 0;
    }
    .name_value, .invalid-feedback {
        font-weight: normal
    }
    .form-control[readonly] {
        background-color: #ffffff;
    }
    .passwordInfo{
        font-size: 11px;
    }
    .form-group{
        margin: 0px;
        padding-left: 22px;
    }
    .btn-possison{
        padding-top: 20px;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .pre {
        white-space: pre-wrap;
    }
    .active-color-box{
        background: #451493;
        border-color: #FFF;
        width: 130px;
    }
    .non-active-color-box{
        background: #bdbebd;
    }
    .text{
        font-size: 25px;
    }
    .text-area{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .text-box{
        display: block;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    .header-margin{
        top:250px;
    }
    .navigation{
        padding-top:15px;
        padding-bottom:40px;
    }
    .text-color{
        color: #451493;
    }
    .table th, .table td {
        border-top: 1px solid #fff;
    }
    .text-size{
        font-size: 10px;
    }
    .mail_value{
        margin-top: 8px;
    }
    .values{
        margin-top: 6px;
    }
    .password-space{
        margin-bottom:-22px;
    }
    /*ボタンのスタイル*/
    .btn-primary{
        width: 130px;
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active,
    .btn-outline-primary:not(:disabled):not(.disabled).active, .show >
    .btn-outline-primary.dropdown-toggle {
        color: #212529;
        background-color: #C4C4CC!important;
        border-color: #E2E6EA;
    }
    .btn-outline-primary:focus, .btn-outline-primary.focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary {
        width: 130px;
        color: #212529;
        background-color: #E2E6EA;
        border-color:  #E2E6EA;
    }
    .btn-outline-primary:hover {
        color: #212529;
        background-color: #c4c4cc !important;
        border-color: #c4c4cc !important;
    }
    .form-control.is-invalid {
        border-color: #e3342f;
    }
    .form-control.is-invalid:focus {
        box-shadow: 0 0 0 0.2rem rgb(227 52 47 / 25%);
    }

    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }

    .error-message {
        display: block;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #e3342f;
        line-height: 1.4;
        word-wrap: break-word;
        max-width: 300px;
    }

    /*PC PAD用css*/
    @media screen and (min-width: 479px) {
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 77px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors-hiddens-text{
            visibility:hidden;
            height: 51px;
            margin-top: 4px;
            margin-bottom: 32px;
        }
        .invalid-errors-hiddens-pass{
            visibility:hidden;
            height: 40px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:40px;
            height:auto !important;
            height:40px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors-password-confirmation-hiddens{
            min-height:40px;
            height:auto !important;
            height:40px;
            margin-top: 4px;
            margin-bottom: 47px;
        }
        .invalid-errors-hiddens-birthDate{
            min-height:40px;
            height:auto !important;
            height:40px;
            margin-top: 4px;
            margin-bottom: 47px;
        }
        .invalid-errors-text{
            min-height: 10px;
            height: auto !important;
            height: 10px;
            margin-top: 5px;
            margin-bottom: 6px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 50px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors-hiddens-text{
            visibility:hidden;
            height: 31px;
            margin-top: 4px;
            margin-bottom: 42px;
        }
        .invalid-errors-hiddens-pass{
            visibility:hidden;
            height: 13px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 1px;
            margin-bottom: 3px;
        }
        .invalid-errors-password-confirmation-hiddens{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 1px;
            margin-bottom: 53px;
        }
        .invalid-errors-hiddens-birthDate{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 1px;
            margin-bottom: 53px;
        }
        .invalid-errors-text{
            min-height: 10px;
            height: auto !important;
            height: 10px;
            margin-top: -1px;
            margin-bottom: 2px;
        }
        .col-form-label{
            padding-top: 0px;
            padding-bottom:0px;
        }
        .btn-position{
            padding-top: 10px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .mail_value{
            margin-top: 0px;
            margin-bottom: 15px;
        }
        .password-space{
            margin-bottom:-22px;
            padding-bottom: 0px;
        }
        .main_title{
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title{
            font-size: 1.3rem;
            margin-bottom: 0px;
        }
        .navigation{
            padding-top: 0px;
            padding-bottom:15px;
        }

    }
    /*スマホ用css*/
    @media screen and (max-width: 471px) {
        .box-area[data-v-40212d93] {
            height: 90px;
        }
        .form-group{
            padding-left: 0px;
        }
    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
